import { Flex, Stack, Text } from '@chakra-ui/react';

import { useGetEddyStats } from '../hooks/useGetEddyStats';
import { useTranslation } from 'react-i18next';

export default function AiAgentAdminEngagementStatsGroup() {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useGetEddyStats();

  if (isLoading || isError) return null;

  return (
    <Stack spacing={4}>
      <Text fontSize="22px" fontWeight={600} color="baseBlack">
        {t('admin.aiAgent.engagement.title')}
      </Text>

      <Flex
        backgroundColor="neutral.0"
        borderRadius="16px"
        border="1px solid"
        borderColor="neutral.100"
      >
        {data.map((stat) => (
          <Stack
            key={stat.label}
            flex={1}
            borderRight="1px solid"
            borderRightColor="neutral.100"
            paddingTop={6}
            paddingBottom={4}
            paddingLeft={6}
            paddingRight={4}
          >
            <Text fontSize="12px" fontWeight={600} color="neutral.1400">
              {stat.label}
            </Text>

            <Text fontSize="24px" fontWeight={600} color="neutral.1400">
              {stat.value}
            </Text>
          </Stack>
        ))}
      </Flex>
    </Stack>
  );
}
